export default __webpack_public_path__ + "static/media/quara.8dcb97a0.svg";